<template>
  <div :class="classes" class="bordered-content">
  	<div class="template">
  		<div class="airplane" v-if="showAirplane"></div>
  		<div class="background"></div>
	  	<div class="border-box"></div>
	  	<div class="video-modal" v-if="modal">
	  		<div class="video-container">
	  			<div class="iframe-container">
					<youtube ref="youtube" @ended="hideVideo" :player-vars="playerVars" :video-id="videoId"></youtube>
				</div>
				<div class="close-modal" v-on:click="hideVideo">
					<div class="menu-icon close">
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>
		</div>
	  	<div class="template-content">
	  		<h1 class="barlow stagger-in" v-html="header"></h1>
		  	<h2 class="stagger-in" v-html="main"></h2>
		  	<p class="barlow stagger-in" v-html="sub"></p>
		</div>
	  </div>
	</div>
</template>

<script>
	import { TimelineMax, Power2 } from 'gsap';
	import { gsapCustomEase } from '../util';

  export default {
    name: 'BorderedContent',
    props: {
    	header: String,
    	main: String,
    	sub: String,
    	classes: Array,
    	page: String,
    	index: Number,
    	indexValue: Number,
    	countValue: Number,
    	finishTransition: Function,
    	changeSlide: Function
    },
    created () {
    	// console.log(this.$props)
    },
    data() {
	    return {
	    	videoId: 'gKe_KLehIok',
			playerVars: {
				autoplay: 1,
				rel: 0
			}
	    }
	  },
    computed: {
    	modal: function() {
    		return this.page === 'home' && this.index === 0
    	},
    	player() {
	      return this.$refs.youtube.player
	    },
	    showAirplane() {
	    	return this.page === 'home' && this.index === 2
	    }
    },
    methods: {
    	hideVideo: function() {
    		let tl = new TimelineMax()
    		let $el = this.$el;
    		let staggerEl = $el.querySelectorAll('.stagger-in')
    		let modal = $el.querySelector('.video-modal')
    		let border = $el.querySelector('.border-box');
    		this.player.pauseVideo();


    		tl.to(modal, 1, {opacity: 0, ease:Power2.easeOut})
    		.staggerTo(staggerEl, 1.2, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.32, '-=0.1')
    		.to(border, 1.2, {opacity: 0.92, ease:Power2.easeInOut}, 0.64)
    		.call(this.setNextTimer)

    	},
    	setNextTimer: function() {
    		let _this = this
    		setTimeout(function(){
    			_this.changeSlide();
    		}, 1600)
    	},
    	transitionIn: function (dir) {
    		if(this.page === 'home' || this.page === 'neighbor') {
    			let tl = new TimelineMax({onComplete: this.transitionInComplete})
    			let $el = this.$el;
    			let bg = $el.querySelector('.background')
	    		let staggerEl = this.$el.querySelectorAll('.stagger-in')
	    		let border = $el.querySelector('.border-box');

	    		tl.set(staggerEl, {opacity: 0, y: 16})
	    		.addLabel('start')

	    		if(this.modal){
	    			let modal = $el.querySelector('.video-modal')
	    			tl.set(border, {opacity: 0})
	    			// .set(modal, {opacity: 0})
	    			// .to(modal, 0.8, {opacity: 1}, 0.64)
	    		} else {
	    			tl.staggerTo(staggerEl, 1.2, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.32, 0.64)
	    		}
				
				if (this.index === 0){
					// console.log("FADE IN BG")
	    			tl.set(bg, {opacity: 0}, 'start')
	    			.to(bg, 1.2, {opacity: 1}, 'start')
	    		}
	    		if((this.index === 2 && this.page === 'home') || (this.index === 1 && this.page === 'neighbor')){
	    			let border = $el.querySelector('.border-box')
	    			let airplane = $el.querySelector('.airplane')
	    			if(airplane){
	    				tl.set(airplane, {opacity: 0}, 'start')
	    				tl.to(airplane, 1.2, {opacity: 1}, 'start+=0.64')
	    			}
	    			// console.log("BRING IN LAST SLIDE", bg)
	    			tl.set([bg, border], {opacity: 0}, 'start')
	    			.to(bg, 1.2, {opacity: 1, ease:Power2.easeInOut}, 'start+=0.64')
	    			.to(border, 1.2, {opacity: 0.92, ease:Power2.easeInOut}, 'start+=0.64')
	    		}

	    		if(this.index === 1 && this.page === 'home'){
	    			tl.call(this.setNextTimer)
	    		}
    		} else{
    			let tl = new TimelineMax({onComplete: this.transitionInComplete})
    			let $el = this.$el;
    			let bg = $el.querySelectorAll('.background');
	    		let staggerEl = $el.querySelectorAll('.stagger-in');
	    		let border = $el.querySelector('.border-box')

	    		tl
	    		.set(bg, {yPercent: dir*100, opacity: 1})
	    		.set(border, {opacity: 0})
	    		.set(staggerEl, {opacity: 0, y: dir*16})
	    		.to(bg, 0.8, {yPercent: 0, ease: Power2.easeInOut})
	    		.addLabel('wipe')
	    		.to(border, 0.8, {opacity: 0.92, ease:Power2.easeOut}, 'wipe')
	    		.staggerTo(staggerEl, 1.2, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.32, 'wipe-=0.24')
	    		.set(bg, {clearProps: 'transform'})

	    		let slides = document.querySelectorAll('.slide');
		        tl.set(slides, {clearProps: 'opacity'})
    		}
    	},
    	transitionOut: function() {
    		let tl2 = new TimelineMax({onComplete: this.transitionOutComplete})
    		let staggerEl = this.$el.querySelectorAll('.stagger-in')

    		tl2
    		.set(this.$el, {opacity: 1})
    		.staggerTo(staggerEl, 0.32, {opacity: 0, y: -16, ease: Power2.easeIn}, 0.08)
    	},
    	transitionInComplete: function() {
			// console.log("ENABLE SITE INTERACTIONS")
			this.finishTransition();
    	},
    	transitionOutComplete: function() {
    		// console.log("CLEAN UP SLIDE")
    	}
    }
  }
</script>

<style lang="scss">
	@import '../sass/variables';
	.bordered-content{
		color: #fff;
		.background, .stagger-in{
			opacity: 0;
		}
		.video-modal{
			position: absolute;
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.4);
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 9999;
			left: 0;
			top: 0;
			.close-modal{
				width: 30px;
				height: 30px;
				margin-left: 10px;
				cursor: pointer;
				@media #{$phoneQuery}{
					position: absolute;
					margin: 0;
					right: 0;
					top: 4vw;
				}
			}
			.video-container{
				display: flex;
				justify-content: center;
				@media #{$phoneQuery}{
					width: 100%;
				}
			}
			.iframe-container{
				width: 640px;
				max-width: 92%;
				padding-bottom: 51.85%;
				height: 0;
				position: relative;
				display: table;
				iframe{
					position: absolute;
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}
		.template{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			flex-direction: column;
		}
		.border-box{
			@include vw-pixels((
				'width': 500,
				'height': 383
			), 1.4);
			border: 30px solid $blue;
			position: absolute;
			opacity: 0.92;
			z-index: 0;
			display: none;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			@media #{$phoneQuery}{
				border: 20px solid $blue;
			}
		}
		.template-content{
			text-align: center;
			z-index: 1;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 100%;
			@include vw-pixels((
				'height': 330
			), 1.5);
			h1{
				position: absolute;
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center;
				width: 100%;
				line-height: 1.1;
				@include vw-pixels((
					'height': 44,
					'top': -22
				));
			}
			h2{
				@include vw-pixels((
					'font-size': 58
				), 1.2);
				line-height: 1.2;
			}
			p{
				@include vw-pixels((
					'font-size': 16,
					'margin-top': 26
				), 1.4);
			}
			@media #{$phoneQuery}{
				width: 73vw;
			}
		}


		//HOME STYLES
		&.home-0, &.home-2{
			.border-box{
				display: block;
			}
		}
		&.home-0{
			.background{
				background-image: url('../assets/images/homepage-0-bg.jpg');
			}
			// z-index: 2!important;
		}
		&.home-0, &.home-1, &.neighbor-0{
			h1{
				background-image: url('../assets/images/homepage-0-header.png');
			}
		}
		&.home-2{
			.background{
				background-image: url('../assets/images/homepage-2-bg.jpg');
			}
			.airplane{
				z-index: 1;
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0%;
				top: 0;
				background-position: center;
				background-image: url('../assets/images/homepage-airplane.png');
				background-repeat: no-repeat;
				background-size: cover;
				opacity: 0;
			}
			.template-content{
				justify-content: flex-end;
			}
			h1{
				white-space: nowrap;
				line-height: 1.2;
				@include vw-pixels((
					'font-size': 16,
					'top': -120
				));
				span{
					color: $maroon;
					@include vw-pixels((
						'font-size': 22
					));
				}
			}
			h2{
				line-height: 1;
				@include vw-pixels((
					'font-size': 80
				));
			}
			p{
				margin-top: 0;
				color: $maroon;
				@include vw-pixels((
					'margin-bottom': 26,
					'font-size': 16
				));
			}
			@media #{$phoneQuery}{
				.template-content{
					width: 90%;
					h1{
						font-size: 3vw;
						span{
							font-size: 140%;
							display: block;
						}
					}
					h2{
						font-size: 12vw;
						span{
							display: block;
						}
					}
					p{
						font-size: 3.2vw;
						margin-bottom: 8vw;
					}
				}
			}
		}

		//EXPERIENCE STYLES
		&.experience{
			.background{
				background-color: $orange;
			}
			h1{
				background-image: url('../assets/images/experience-0-header.png');
				@include vw-pixels((
					'top': -20
				));
			}
		}
		@media #{$phoneQuery}{
			&.experience-0{
				.template-content{
					width: 81vw;
				}
			}
		}
		&.experience-4{
			h1{  background-image: url('../assets/images/sound-7-header.png'); }
			@media #{$phoneQuery}{
				.template-content{
					width: 82vw;
					h2{
						font-size: 6vw;
					}
				}
			}
		}

		//NEIGHBOR STYLES
		&.neighbor-0, &.neighbor-1{
			.border-box{
				display: block;
			}
		}
		&.neighbor-0{
			.background{
				background-image: url('../assets/images/neighbor-0-bg.jpg');
			}
			@media #{$phoneQuery}{
				.template-content{
					width: 100%;
					h2{
						font-size: 6vw;
						margin: 0 auto;
						width: 80%;
					}
				}
			}
		}
		&.neighbor-1{
			.background{
				background-image: url('../assets/images/neighbor-1-bg.jpg');
			}
			h2{
				@include vw-pixels((
					'font-size': 80
				), 1.2);
			}
			p{
				margin-top: 0;
				@include vw-pixels((
					'font-size': 16
				), 1.7);
			}
			@media #{$phoneQuery}{
				.template-content{
					width: 92%;
				}
			}
		}



		&.convenience-4{
			.background{
				background: $blue;
			}
			h1{
				background-image: url('../assets/images/sound-7-header.png');
			}
		}

		&.security{
			.background{
				background: #fff;
			}
			.border-box{
				display: block;
			}
			h1{
				background-image: url('../assets/images/security-1-header.png');
			}
			.template-content{
				h2{
					color: #000;
				}
			}
		}
		&.security-1{
			@media #{$phoneQuery}{
				.template-content{
					width: 92%;
					h2{
						font-size: 6vw;
					}
				}
			}
		}
		&.sound-0{
			.background{
				background-image: url('../assets/images/sound-0-bg.jpg');
			}
			.border-box{
				display: block;
			}
			h2{
				@include vw-pixels((
					'font-size': 80
				), 1.01);
			}
			p{
				margin-top: 0;
				color: $maroon;
				@include vw-pixels((
					'font-size': 16
				), 1.5);
			}
			@media #{$phoneQuery}{
				.template-content{
					width: 75vw;
				}
			}
		}
		&.sound-7{
			.background{
				background: $orange;
			}
			h1{
				background-image: url('../assets/images/sound-7-header.png');
			}
			p{
				color: $maroon;
			}
			@media #{$phoneQuery}{
				.template-content{
					width: 87vw;
				}
				h2{
					font-size: 6.4vw;
				}
			}
		}
	}
</style>